import React from 'react';
import { section, query } from '@jump/pages';
import Entry from './js/Entry';
import YearSelector from './js/YearSelector';

class History extends React.Component {
  state = { selected: 0 };

  _onNextClick = () => {
    const { queries: { history } } = this.props;

    this.setState({
      selected: Math.min(
        this.state.selected + 1,
        history.results.length - 1
      )
    });
  };

  _onPrevClick = () => {
    this.setState({
      selected: Math.max(
        this.state.selected - 1,
        0
      )
    });
  };

  _onYearClick = (idx) => {
    this.setState({ selected: idx });
  };

  render() {
    const {
      queries: {
        history,
      }
    } = this.props;

    const {
      selected,
    } = this.state;

    return (
      <div className="c-History">
        {history.loaded &&
          <YearSelector
            years={history.results.map(({ year }) => year)}
            selected={selected}
            onNextClick={this._onNextClick}
            onPrevClick={this._onPrevClick}
            onYearClick={this._onYearClick}
          />
        }

        {history.loaded && history.results.map((entry, idx) => (
          <Entry
            key={entry.id}
            active={idx === selected}
            image={entry.image}
            summary={entry.summary}
          />
        ))}
      </div>
    );
  }
}

export default section({
  name: 'history',
  component: History,
  queries: [
    query('history')
  ],
});



// WEBPACK FOOTER //
// ./plugins/app/site/pagesections/history/index.js